import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import * as types from './types';
import { fetchWishlist, addWishlistItem, deleteWishlistItem } from '~/services/wishlist';
export default {
  fetchWishlistItems(_ref) {
    var _this = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref;
      const {
        wishlist
      } = yield fetchWishlist(_this);
      commit(types.SET_WISHLIST_ITEMS, wishlist);
    })();
  },

  addWishlistItem(_ref2, reference) {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref2;

      try {
        yield addWishlistItem(_this2, reference);
        commit(types.ADD_WISHLIST_ITEM, {
          product: {
            reference
          }
        });
      } catch (error) {
        _this2.$logger.error(error);

        throw new Error('ADD_WISHLIST_FAILED');
      }
    })();
  },

  deleteWishlistItem(_ref3, reference) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      let {
        commit
      } = _ref3;

      try {
        yield deleteWishlistItem(_this3, reference);
        commit(types.DELETE_WISHLIST_ITEM, reference);
      } catch (error) {
        _this3.$logger.error(error);

        throw new Error('REMOVE_WISHLIST_FAILED');
      }
    })();
  }

};